<template>
    <div class="data-card">
        <div class="data-card__title">{{ `${member.firstName} ${member.lastName}` }}</div>
        <div class="data-card__line">
            <v-icon small color="#ad282d">mdi-card-account-details-outline</v-icon>
            <span>{{ getActiveCard(member.cards, 'PARON') || 'Χωρίς ενεργή κάρτα' }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            member: {
                type: Object,
                default: null
            }
        },
        data: () => {
            return {
                getActiveCard(cards, type) {
                    var filteredCards = cards.filter(card => (card.active === true && card.type === type))
                    let text = ''
                    if (filteredCards.length > 0) {
                        filteredCards.forEach(card => {
                            text += card.number + ', '
                        })
                    }
                    text = text.slice(0, -2)
                    return text
                }
            }
        }
    }
</script>

<style scoped>
.data-card {
    width: 100%;
    height: 100%;
    padding: 16px 18px;
    border: 1px solid rgba(27, 47, 90, 0.1);
    border-radius: 14px;
    background: #fff;
    color: #1b2f5a;
}
.data-card__title {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.35;
}
.data-card__amount {
    flex: 0 0 auto;
    color: #ad282d;
}
.data-card__line {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    margin-top: 6px;
    font-size: 14px;
    color: rgba(27, 47, 90, 0.75);
}
</style>
